import { Plural, Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { ArticleWithRelations, RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import ClientStepper from '@/routes/Brand/Requests/Request/components/shared/ClientStepper';
import { PendingShipmentPreparation } from '@/routes/Brand/Requests/Request/components/shared/PendingShipmentPreparation';

import { StepMessage } from '../../shared/StepMessage';

const Transit = ({ request }: { request: RequestWithRelations }) => {
  const activeArticlesInTransit = request.articles.filter(
    (article) => article.step?.step === 'transit' && !article.cancelledAt
  );
  const isPendingTransit = activeArticlesInTransit.some(
    (article) => !!request.storeId && article.atEntityId === request.storeId
  );

  return (
    <BrandRequestMainContent>
      <Stack gap="1rem">
        <ClientStepper request={request} />

        {isPendingTransit && (
          <PendingShipmentPreparation
            request={request}
            articlesInTransit={activeArticlesInTransit}
          />
        )}

        {!isPendingTransit && <InTransitHeader articlesInTransit={activeArticlesInTransit} />}

        <ClientArticlesList request={request} showPrice={!!request.client} showArticleComment />
      </Stack>
    </BrandRequestMainContent>
  );
};

const InTransitHeader = ({ articlesInTransit }: { articlesInTransit: ArticleWithRelations[] }) => {
  return (
    <StepMessage
      message={
        <Trans id="store.request.transit.in-transit.store-shipment">
          The{' '}
          <Plural
            value={articlesInTransit.length}
            one="item is on its"
            other="items are on their"
          />{' '}
          way to the workshop to be taken care of.
        </Trans>
      }
    />
  );
};

export default Transit;
